import React from 'react';
import { View, ScrollView } from 'react-native';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import Svg from '@styles/icons/svg';
import ColorWrapper from '@styles/colors/index';
import AnimatedTable from '@components/settings/components/common/animatedTable';
import { scale } from '@components/frame';
import { getDevices } from '@reducers/device';
import Header from '@components/settings/v2/common/SettingsHeader';
import { SCREEN_PADDING_HORIZONTAL, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageDevices } from './hooks/useManageDevices';

const Devices = ({ C, getDevices, rootStack }) => {
  const { devices, loaded, isDeviceMore, navigateToDeviceDetails, navigateToAddDevice } = useManageDevices({ rootStack });

  const ArrowComponent = () => {
    return (
      <View style={{ marginLeft: scale(5) }}>
        <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
      </View>
    );
  };

  return (
    <View style={{ width: '100%', height: '100%' }}>
      <Header name={'Devices'} action={navigateToAddDevice} />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View testID={TEST_IDS.settingsScreen.devicesTable} style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }}>
          <AnimatedTable
            {...{
              C,
              loaded,
              array: devices,
              headerSize: 50,
              lineSize: 63,
              showMoreSize: 63,
              baseCount: 20,
              showMoreText: i18n.t('SHOW MORE DEVICES'),
              showMoreArrow: false,
              showAllButton: isDeviceMore,
              load: getDevices,
              initialFilter: 'LastUsedOn',
              initialDirection: false,
              onPress: (i) => navigateToDeviceDetails(i.deviceId),
              config: [
                {
                  key: 'name',
                  title: 'Name',
                  orderBy: 'Name',
                  sort: true,
                  width: '25%',
                  color: C('Label / Light / Primary'),
                  titleColor: C('Label / Light / Secondary'),
                  style: { marginTop: scale(6) },
                  bottom: {
                    key: 'registeredOnFrom',
                    color: C('Label / Light / Secondary'),
                    style: { marginTop: scale(1) },
                  },
                },
                {
                  key: 'deviceType',
                  title: 'Type',
                  orderBy: 'DeviceType',
                  sort: true,
                  width: '18%',
                  color: C('Label / Light / Secondary'),
                  titleColor: C('Label / Light / Secondary'),
                  right: {
                    key: 'mode',
                    color: C('Label / Light / Tertiary'),
                  },
                },
                {
                  key: 'lastUsedOnFormatted',
                  title: 'Last used',
                  orderBy: 'LastUsedOn',
                  sort: true,
                  width: '18%',
                  color: C('Label / Light / Secondary'),
                  titleColor: C('Label / Light / Secondary'),
                },
                {
                  key: 'lastLocation',
                  title: 'Location',
                  orderBy: 'LastLocation',
                  sort: true,
                  width: '15.5%',
                  color: C('Label / Light / Secondary'),
                  titleColor: C('Label / Light / Secondary'),
                  bottom: {
                    key: 'ip',
                    color: C('Label / Light / Secondary'),
                  },
                },
                {
                  key: 'lastUsedBy',
                  title: 'Last user',
                  orderBy: 'LastUsedBy',
                  sort: true,
                  width: '23.5%',
                  color: C('Label / Light / Secondary'),
                  titleColor: C('Label / Light / Secondary'),
                },
                {
                  function: ArrowComponent,
                  title: '',
                },
              ],
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
};

export default connect(null, { getDevices })(ColorWrapper(Devices));
